import { render, staticRenderFns } from "./BirthdayImport.vue?vue&type=template&id=95156b8e&"
import script from "./BirthdayImport.vue?vue&type=script&lang=js&"
export * from "./BirthdayImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports